import ObjectBuilderInterface from "@/modules/api/object-builder.interface";

import FactoryRushCapacityMode from "./factory-rush-capacity-mode.model";

export default class FactoryRushCapacityModeFactory
  implements ObjectBuilderInterface<FactoryRushCapacityMode> {
  public buildFromJSON(data: { [key: string]: any }): FactoryRushCapacityMode {
    const value = new FactoryRushCapacityMode(data.id);

    (value as any).fCreatedAt = new Date(data.createdAt);

    value.isNew = false;

    return value;
  }
}
